/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable no-useless-concat */
/* eslint-disable max-len */
/* eslint-disable no-unused-expressions */
import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, IconButton, Backdrop, CircularProgress, Tooltip, Autocomplete, createFilterOptions, TextField } from '@mui/material';
import axios from 'axios';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CloseIcon from '@mui/icons-material/Close';
/* adding dependencies for text editor Start */
import { EditorState, ContentState, convertFromHTML } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import { convertToHTML } from 'draft-convert';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { VeoliaButton } from '@veolia.com/vds-react-components';
/* adding dependencies for text editor End */
import Draggable from 'react-draggable';
import { getUserListData } from '../../shared/api/url-helper';
import './styles.css';

// const defaultStr = 'Copy my email.';
const filter = createFilterOptions();

function File_Share(props) {
  const [convertedContent, setConvertedContent] = useState(null);
  const [fetchLoading, setFetchLoading] = useState(false);
  // React States
  const [isSubmitted] = useState(false);
  const fileShare = useRef();
  const [dataSelect, setDataSelect] = React.useState([]);
  const [userData, setUserData] = React.useState([]);
  // Add a new state to track selected options in Autocomplete
  const [selectedOptions, setSelectedOptions] = useState([]);
  // the value of the search field
  const [name, setName] = useState([]);
  // the search result
  const [foundUsers] = useState('');
  // const [copyEmail, setCopyEmail] = useState('');
  const { t } = useTranslation();
  const translateObject = t;
  const { visible_fileSharing, setVisible_fileSharing, onSave_saveButton, text, setcolormatch, ColorChangeShare } = props;
  const getUserName = sessionStorage.getItem('user_name').split(' ')[0];
  const [subjectValue, setSubjectValue] = useState(`${getUserName} has shared ` + `"${text}.win" file with you`);

  let url = '';
  url = `${window.location.origin}/main?${text.split('.win')[0]}.json`;
  const [bodyValue] = useState(`
    <p> Hi </p>
    <p> I would like to share <a href=${url} target='_blank'><strong><code>${text}.win</code></strong> (${url})</a> file with you. </p>
    <p> Please login to Winflows Design Simulator to view the shared file. </p>
    <p> <a href=${window.location.origin} target='_blank'>${window.location.host}<br /></a> </p>
    <p></p>
    <p> Thanks,<br />${getUserName} </p>
  `);
  /* set default value for text editor Start */
  const [editorState, setEditorState] = useState(
    () => EditorState.createWithContent(
      ContentState.createFromBlockArray(
        convertFromHTML(bodyValue)
      )
    ),
  );
  const replaceTage = (str) => {
    const htmlcontent = document.createElement('div');
    htmlcontent.innerHTML = str;
    htmlcontent.querySelectorAll('p').forEach((ele, index) => {
      if (ele.innerHTML.trim() && htmlcontent.querySelectorAll('p').length - 1 !== index) {
        ele.style.margin = 0;
      }
    });
    return htmlcontent.innerHTML;
  };
  useEffect(() => {
    const html = convertToHTML(editorState.getCurrentContent());
    setConvertedContent(html);
  }, [editorState]);
  const [toolbarOptions] = useState({
    options: ['blockType', 'inline', 'textAlign', 'list', 'link'],
    list: { inDropdown: false, options: ['unordered', 'ordered'] },
    blockType: {
      inDropdown: true,
      options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6'],
      className: 'editor-heading-wrapper',
      dropdownClassName: 'editor-heading',
    },
    inline: { inDropdown: false, options: ['bold', 'italic', 'underline'] },
    textAlign: {
      inDropdown: true,
      options: ['left', 'center', 'right', 'justify'],
      className: 'text-align-wrapper',
      dropdownClassName: 'text-align-heading'
    },
  });
  /* set default value for text editor End */
  React.useEffect(() => {
    setFetchLoading(true);
    getUserListData();
    const UserListData = JSON.parse(sessionStorage.getItem('UserListData'));
    if (UserListData) {
      setUserData([...UserListData]);
      setFetchLoading(false);
    } else {
      const userListCheck = setInterval(() => {
        const UserListData1 = sessionStorage.getItem('UserListData');
        if (UserListData1) {
          clearInterval(userListCheck);
          setUserData([...UserListData1]);
          setFetchLoading(false);
        }
      }, 500);
    }
  }, []);
  const handleSubmit = (event) => {
    // Prevent page reload
    event.preventDefault();
    if (name.length === 0) {
      const ele = (fileShare && fileShare.current) ? fileShare.current : fileShare;
      ele.querySelector('.MuiAutocomplete-root').classList.add('error');
      return;
    }
    const usersName = {
      'subject': subjectValue,
      'to': name,
      'body_text': replaceTage(convertedContent), // bodyValue
      'body_html': replaceTage(convertedContent) // bodyValue
    };
    axios.post('https://oc4sydl8b6.execute-api.us-east-1.amazonaws.com/winflows/mail', usersName);
    setVisible_fileSharing(false);
    if (ColorChangeShare) {
      setcolormatch(false);
    }
    onSave_saveButton('share', usersName.to);
  };
  const handleCloseModal = () => {
    if (ColorChangeShare) {
      setcolormatch(false);
    }
    setVisible_fileSharing(false);
  };
  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };
  const copyEmailSharedProject = () => {
    const userEmail = sessionStorage.getItem('user_email');
    if (userEmail) {
      // navigator.clipboard.writeText(userEmail);
      if (!name.includes(userEmail)) {
        setName([...name, userEmail]);
        // Create an option object for Autocomplete
        const emailOption = {
          ACCOUNT: '',
          EMAIL: userEmail,
          OEMAIL: userEmail,
          STATUS: 'TRUE'
        };
        // Add to selected options if not already there
        if (!selectedOptions.some(opt => opt.EMAIL === userEmail)) {
          setSelectedOptions([...selectedOptions, emailOption]);
        }
      }
    }

    // let copyText = '';
    // document.querySelectorAll('.email-box-shared .MuiChip-label').forEach((ele, index) => {
    //   copyText += ele.innerText;
    //   if (index < document.querySelectorAll('.MuiChip-label').length - 1) {
    //     copyText += ',';
    //   }
    // });
    // if (copyText) {
    //   navigator.clipboard.writeText(copyText).then(() => {
    //     setCopyEmail(<span style={{ color: 'blue' }}>Copied.</span>);
    //     setTimeout(() => { setCopyEmail(''); }, 1000);
    //   });
    // }
  };
  // JSX code for login form
  const renderForm = (
    <div className="form">
      <form onSubmit={handleSubmit}>
        <div className="input-container email-box-shared">
          <label className='no-drag'><b>{translateObject('Email')}</b></label>
          <div className='shared-email-box copy'>
            <Autocomplete
              multiple
              id="tags-outlined"
              options={dataSelect}
              getOptionLabel={(option) => option.EMAIL}
              filterSelectedOptions
              value={selectedOptions}
              onChange={(event, newValue) => {
                const allEmail = [];
                newValue.forEach((ele) => {
                  allEmail.push(ele.EMAIL);
                });
                setName(allEmail);
                setSelectedOptions(newValue);
              }}
              filterOptions={(options, params) => {
                const filtered = filter(options, params);
                const { inputValue } = params;
                // Suggest the creation of a new value
                const isExisting = options.some((option) => inputValue === option.EMAIL);
                if (inputValue !== '' && !isExisting) {
                  if (validateEmail(inputValue)) {
                    filtered.push({
                      ACCOUNT: '',
                      EMAIL: inputValue,
                      OEMAIL: 'No email!!!',
                      STATUS: 'TRUE',
                      inputValue,
                    });
                  }
                }
                return filtered;
              }}
              onInputChange={(event, newInputValue) => {
                if (newInputValue.length > 3) {
                  setDataSelect([...userData]);
                } else {
                  setDataSelect([]);
                }
              }}
              renderInput={(params) => (
                <TextField className={name.length >= 5 ? 'disabled-input' : ''}
                  {...params}
                  placeholder="Type 4 character to search..."
                />
              )}
              sx={{ minHeight: '40px', maxHeight: '80px' }}
            />
            <div className='copy-email'>
              <Tooltip title="Include my Email">
                {/* {copyEmail && (<span className='shared-tooltip'>{copyEmail}</span>)} */}
                <VeoliaButton
                  htmlType="button"
                  icon="copy_all"
                  iconOnly
                  iconPosition="left"
                  size="small"
                  variant="secondary"
                  className=''
                  // onMouseOver={(e) => setCopyEmail(defaultStr)}
                  onClick={(e) => copyEmailSharedProject()}
                  // onMouseLeave={() => setCopyEmail('')}
                />
              </Tooltip>
            </div>
          </div>
        </div>
        <div className="input-container">
          <label className='no-drag'><b>{translateObject('Subject')}</b></label>
          <input className='no-drag' style={{ 'padding': '7.5px 4px 7.5px 6px' }} type="text" name="subject" value={subjectValue} onChange={(e) => setSubjectValue(e.target.value)} />
        </div>
        <div className="input-container">
          <label className='no-drag'><b>{translateObject('Message')}</b></label>
          <Editor
            editorState={editorState}
            onEditorStateChange={setEditorState}
            wrapperClassName="editor-wrapper-class"
            editorClassName="editor-text-class"
            toolbarClassName="editor-toolbar-class"
            toolbar={toolbarOptions}
          />
        </div>
        <div className="button-container">
          <input type="submit" value={translateObject('Share')} data-testid="submitshare" className='submitshare no-drag Primary_Default_Button' />
        </div>
        <div className="user-list">
          {foundUsers && foundUsers.length > 0 && foundUsers.length < 10 ? (
            foundUsers.map((user) => (
              <li key={user.ACCOUNT} className="user">
                <span className="user-id">{user.ACCOUNT.split('(')[0]}</span>
                <span className="user-name">{user.EMAIL}</span>
                <span className="user-copy">
                  <Tooltip title="Copy Email">
                    <IconButton
                      data-testid='copy'
                      aria-label="copy"
                      onClick={() => { setName(user.EMAIL); }}
                      size="small"
                    >
                      <ContentCopyIcon />
                    </IconButton>
                  </Tooltip>
                </span>
              </li>
            ))
          ) : (
            <h1 />
          )}
        </div>
      </form>
    </div>
  );

  return (
    <Draggable hanndle=".login-form-header" cancel='#tags-outlined, .no-drag, .title, .editor-wrapper-class'>
      <Modal open={visible_fileSharing} className='fileshare-overlay'>
        <div>
          <Backdrop open={fetchLoading} style={{ backgroundColor: 'transparent' }}>
            <CircularProgress color="inherit" style={{ color: '#4b93f4' }} />
          </Backdrop>
          <div ref={fileShare} className="fileShare" style={{ opacity: fetchLoading ? 0 : 1 }}>
            <div className="login-form">
              <div className="login-form-header">
                <div className="title">{translateObject('Share File')}</div>
                <div className="closeDialog_fileShare no-drag">
                  <span onClick={handleCloseModal}>
                    <IconButton>
                      <CloseIcon />
                    </IconButton>
                  </span>
                </div>
              </div>
              {isSubmitted ? <div>User is successfully logged in</div> : renderForm}

            </div>
          </div>
        </div>
      </Modal>
    </Draggable>
  );
}

export default File_Share;